import { Styled } from './';
import { FC, useState } from 'react';
import { Button, Checkbox } from 'components/core';

const ITeroSignContract: FC = () => {
  const [isTCAccepted, setIsTCAccepted] = useState(false);
  return (
    <Styled.Container>
      <Styled.ContractContainer>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
          quis lacus neque. Vivamus venenatis magna ac justo rutrum scelerisque.
          In sit amet odio tempus nunc lacinia venenatis. In felis augue,
          convallis quis lobortis et, consectetur nec justo. Nullam sit amet leo
          augue. Nulla sed arcu vel est sodales sodales. Curabitur ipsum est,
          luctus ac augue et, scelerisque finibus lorem. Morbi blandit at lectus
          ac tempus. Vestibulum metus libero, aliquet at pellentesque sit amet,
          consequat non turpis. Nulla congue quam sit amet
        </p>
        <p>
          egestas hendrerit. Morbi arcu metus, malesuada vel consequat et,
          faucibus quis magna. Nullam commodo orci eu augue aliquet consectetur.
          Nullam a elementum nibh. Pellentesque habitant morbi tristique
          senectus et netus et malesuada fames ac turpis egestas. Nulla dictum
          fringilla nisl, non vehicula felis elementum et. Nulla sagittis tortor
          magna, sed pulvinar leo lobortis sit amet. Maecenas pretium tincidunt
          enim, consequat consectetur justo suscipit ut. Ut bibendum vel urna
          eget sagittis. Vestibulum quis lacus interdum, pharetra felis eget,
          volutpat elit. Nam eget lectus porta, sodales arcu sed, dignissim
          ligula. Nulla quis faucibus quam. Sed tristique sit amet risus ac
          dapibus.
        </p>
        <p>
          Morbi eu quam dui. Proin enim tellus, dignissim in arcu nec, suscipit
          placerat nunc. Vivamus consequat nunc a ullamcorper feugiat. Donec eu
          scelerisque massa. Suspendisse potenti. Etiam blandit volutpat libero,
          suscipit placerat libero porttitor quis. Quisque ligula augue, blandit
          eu laoreet id, condimentum a risus. Nulla auctor, libero feugiat
          dapibus ultrices, nunc ex suscipit lacus, vel vestibulum nisl lorem
          eget mi. Praesent sed dapibus enim. Vestibulum efficitur imperdiet
          ligula id vulputate. Pellentesque ante diam, ultrices sit amet
          volutpat nec, consectetur non massa. Donec at eros quis ante rutrum
          porttitor. Curabitur erat arcu, condimentum in lectus a, blandit
          dictum libero. Morbi volutpat bibendum sem quis porttitor. In hac
          habitasse platea dictumst. Nullam congue augue ut mi egestas
          consequat. Vivamus odio mi, congue molestie scelerisque ac, interdum
          et tortor. Curabitur viverra nulla vitae tortor hendrerit molestie.
          Integer eu vehicula velit. Aliquam in dictum leo, vel dapibus felis.
        </p>
        <p>
          Curabitur eget porttitor ligula. Aliquam sagittis elit at ultricies
          fringilla. Sed eget vestibulum lectus. Morbi ligula nibh, blandit
          pharetra venenatis nec, scelerisque a dolor. Praesent efficitur felis
          non ante iaculis, ac mattis ex accumsan. Sed consequat odio in ligula
          blandit tincidunt. Etiam in nulla id lectus tincidunt condimentum.
          Aenean at mauris neque. Praesent porttitor suscipit bibendum. Integer
          sagittis auctor tempor. Nunc rhoncus lorem purus, sed porta lacus
          accumsan quis. Donec lacinia vehicula turpis non finibus. Aliquam
          tincidunt ligula mollis orci pulvinar, a iaculis mi tempus. Nullam ut
          ornare ex, ac varius mi. Sed consectetur mauris lacus, nec venenatis
          orci posuere ut. Aliquam interdum eleifend lectus non maximus. Duis ut
          mi tempus, scelerisque enim cursus, tincidunt lorem. Nullam non dolor
          at erat viverra laoreet eu ut turpis. Vivamus elementum ultricies
          porttitor. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </p>
        <p>
          Morbi eu quam dui. Proin enim tellus, dignissim in arcu nec, suscipit
          placerat nunc. Vivamus consequat nunc a ullamcorper feugiat. Donec eu
          scelerisque massa. Suspendisse potenti. Etiam blandit volutpat libero,
          suscipit placerat libero porttitor quis. Quisque ligula augue, blandit
          eu laoreet id, condimentum a risus. Nulla auctor, libero feugiat
          dapibus ultrices, nunc ex suscipit lacus, vel vestibulum nisl lorem
          eget mi. Praesent sed dapibus enim. Vestibulum efficitur imperdiet
          ligula id vulputate. Pellentesque ante diam, ultrices sit amet
          volutpat nec, consectetur non massa. Donec at eros quis ante rutrum
          porttitor. Curabitur erat arcu, condimentum in lectus a, blandit
          dictum libero. Morbi volutpat bibendum sem quis porttitor. In hac
          habitasse platea dictumst. Nullam congue augue ut mi egestas
          consequat. Vivamus odio mi, congue molestie scelerisque ac, interdum
          et tortor. Curabitur viverra nulla vitae tortor hendrerit molestie.
          Integer eu vehicula velit. Aliquam in dictum leo, vel dapibus felis.
        </p>
        <p>
          Curabitur eget porttitor ligula. Aliquam sagittis elit at ultricies
          fringilla. Sed eget vestibulum lectus. Morbi ligula nibh, blandit
          pharetra venenatis nec, scelerisque a dolor. Praesent efficitur felis
          non ante iaculis, ac mattis ex accumsan. Sed consequat odio in ligula
          blandit tincidunt. Etiam in nulla id lectus tincidunt condimentum.
          Aenean at mauris neque. Praesent porttitor suscipit bibendum. Integer
          sagittis auctor tempor. Nunc rhoncus lorem purus, sed porta lacus
          accumsan quis. Donec lacinia vehicula turpis non finibus. Aliquam
          tincidunt ligula mollis orci pulvinar, a iaculis mi tempus. Nullam ut
          ornare ex, ac varius mi. Sed consectetur mauris lacus, nec venenatis
          orci posuere ut. Aliquam interdum eleifend lectus non maximus. Duis ut
          mi tempus, scelerisque enim cursus, tincidunt lorem. Nullam non dolor
          at erat viverra laoreet eu ut turpis. Vivamus elementum ultricies
          porttitor. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </p>
      </Styled.ContractContainer>
      <Styled.TacContainer>
        <Checkbox
          label="I hereby acknowledge that I have read, understood, and fully agree to
          comply with all the Terms and Conditions set forth, and I accept all
          provisions, requirements, and guidelines outlined within this
          agreement without reservation."
          checked={isTCAccepted}
          onChange={() => setIsTCAccepted(!isTCAccepted)}
        />
      </Styled.TacContainer>
      <Button size="md" disabled={!isTCAccepted}>
        Sign & Submit
      </Button>
    </Styled.Container>
  );
};

export default ITeroSignContract;
